'use client';

import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { Skeleton } from '@/shadcn/components/Skeleton';
import { Button } from '@/shadcn/components/Button';
import { Carousel, CarouselContent, CarouselItem } from '@/shadcn/components/Carousel';
import SliderSkeleton from '../SliderSkeleton';
import styles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Slider = _ref => {
  let {
    title,
    widgets,
    anchor,
    isLoaded
  } = _ref;
  const {
    0: carouselApi,
    1: setCarouselApi
  } = useState();
  const {
    0: canScrollPrev,
    1: setCanScrollPrev
  } = useState(false);
  const {
    0: canScrollNext,
    1: setCanScrollNext
  } = useState(false);
  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    const updateSelection = () => {
      setCanScrollPrev(carouselApi.canScrollPrev());
      setCanScrollNext(carouselApi.canScrollNext());
    };

    updateSelection();
    carouselApi.on('select', updateSelection);
    return () => {
      carouselApi.off('select', updateSelection);
    };
  }, [carouselApi]);
  return /*#__PURE__*/_jsxs("section", _objectSpread(_objectSpread({
    className: "py-8"
  }, anchor && {
    id: `${anchor}`
  }), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "mb-8 flex flex-col justify-between md:mb-14 md:flex-row md:items-end lg:mb-16",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("h2", {
            className: "text-xl font-semibold  md:text-4xl capitalize",
            children: title
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-8 flex shrink-0 items-center justify-center gap-2",
          children: !isLoaded ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Skeleton, {
              className: "h-10 w-10"
            }), /*#__PURE__*/_jsx(Skeleton, {
              className: "h-10 w-10"
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Button, {
              size: "icon",
              variant: "outline",
              onClick: () => {
                carouselApi === null || carouselApi === void 0 ? void 0 : carouselApi.scrollPrev();
              },
              disabled: !canScrollPrev,
              className: "disabled:pointer-events-auto",
              children: /*#__PURE__*/_jsx(ArrowLeft, {
                className: "size-5"
              })
            }), /*#__PURE__*/_jsx(Button, {
              size: "icon",
              variant: "outline",
              onClick: () => {
                carouselApi === null || carouselApi === void 0 ? void 0 : carouselApi.scrollNext();
              },
              disabled: !canScrollNext,
              className: "disabled:pointer-events-auto",
              children: /*#__PURE__*/_jsx(ArrowRight, {
                className: "size-5"
              })
            })]
          })
        })]
      })
    }), !isLoaded ? /*#__PURE__*/_jsx(SliderSkeleton, {}) : /*#__PURE__*/_jsx("div", {
      className: "w-full",
      children: /*#__PURE__*/_jsx(Carousel, {
        setApi: setCarouselApi,
        opts: {
          breakpoints: {
            '(max-width: 768px)': {
              dragFree: true
            }
          }
        },
        children: /*#__PURE__*/_jsx(CarouselContent, {
          className: "ml-[calc(16px-20px)] mr-[16px] 2xl:ml-[calc(50vw-700px+16px-20px)] 2xl:mr-[calc(50vw-700px+16px)]",
          children: widgets === null || widgets === void 0 ? void 0 : widgets.map(widget => /*#__PURE__*/_jsx(CarouselItem, {
            className: "pl-[20px] md:max-w-[452px]",
            children: /*#__PURE__*/_jsxs("div", {
              className: "group flex flex-col justify-between",
              children: [/*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx("div", {
                  className: "flex aspect-[5/3] text-clip rounded-xl",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "flex-1",
                    children: /*#__PURE__*/_jsx("div", {
                      className: clsx('flex items-center justify-center relative size-full origin-bottom transition duration-300 group-hover:scale-105', styles.carouselImgContainer),
                      children: /*#__PURE__*/_jsx("img", {
                        src: `/sharedWidgets/${widget.sharedNamespace}/primary.webp`,
                        alt: `${widget.title} - widget preview image`,
                        className: "size-5/6 object-cover object-center"
                      })
                    })
                  })
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "mb-2 line-clamp-3 break-words pt-4 text-lg font-medium md:mb-3 md:pt-4 md:text-xl lg:pt-4 lg:text-2xl",
                children: widget.title
              }), /*#__PURE__*/_jsx("div", {
                className: "mb-8 line-clamp-2 text-sm text-muted-foreground md:mb-12 md:text-base lg:mb-9 min-h-[3rem]",
                children: widget.description
              }), /*#__PURE__*/_jsxs(Link, {
                href: `/templates/${widget.slug}`,
                className: "flex items-center text-sm",
                children: ["View template", ' ', /*#__PURE__*/_jsx(ArrowRight, {
                  className: "ml-2 size-5 transition-transform group-hover:translate-x-1"
                })]
              })]
            })
          }, widget.id))
        })
      })
    })]
  }));
};

export default Slider;